import { CircularProgress, MuiAlert } from '@fox/atoms';
import { FlexColumnSpaced } from '@fox/layout';
import { captureException, withScope } from '@sentry/browser';
import { useEffect, useState } from 'react';
import { PaymentAddIntentProps, SetupIntentResult } from '../../contracts';

export function IntentAdd(props: PaymentAddIntentProps) {
	const [intentData, setIntentData] = useState<SetupIntentResult | undefined>(undefined);
	const [error, setError] = useState<string | undefined>(undefined);
	const { getIntent, component: Component, provider, ...rest } = props;
	//run the intent mutation

	useEffect(() => {
		getIntent()
			.then(res => {
				if (res?.error) {
					setError(res.error);
				}
				setIntentData(res);
			})
			.catch(e => {
				withScope(s => {
					s.setTag(provider.provider, 'card');
					const id = captureException(e);
					if (e.message) {
						setError(e.message);
					} else {
						setError(`Failed to talk to ${provider.name}, report ${id} to support.`);
					}
				});
			});
	}, []);
	if (!intentData && !error) return <CircularProgress />;

	return (
		<FlexColumnSpaced>
			{error ? <MuiAlert severity="error">{error}</MuiAlert> : null}
			{(!error || !props.disableOnError) && Component ? <Component intentData={intentData} {...rest} /> : null}
		</FlexColumnSpaced>
	);
}
